import { OrangeButton } from '@/components/Buttons';
import { GenericForm, GenericFormBGContainer } from '@/components/GenericForm';
import { Divider } from '@/components/misc';
import { EMPLOYEE_ROLES, EmployeeProps } from '@/interfaces/employee_type';
import { UseFormRegister, Control, FieldErrors } from 'react-hook-form';
import { EmployeeFormData } from './EmployeeForm';
import { Input } from '@/components/_Shared/Form/Inputs/Input';
import { SelectContainer } from '@/components/_Shared/Form/Inputs/Select';
import { Submit } from '@/components/_Shared/Form/Buttons/Submit';

export type EmployeeFormBaseProps = {  
    employee: EmployeeProps
    onSubmit: (e: React.FormEvent<HTMLFormElement>) => void
    method: "POST" | "PUT"
    isProcessing: boolean
    register: UseFormRegister<EmployeeFormData>
    control: Control<EmployeeFormData>
    errors: FieldErrors<EmployeeFormData>
}

export function EmployeeFormBase(props: EmployeeFormBaseProps) {
    const { employee, onSubmit, method, isProcessing, register, control, errors } = props

    return (
        <GenericForm form_id="employee_creation" onSubmit={onSubmit}>
            <GenericFormBGContainer>
                <h2 className="text-2xl font-bold">{method === "POST" ? "Create" : "Update"} Employee</h2>

                <Divider />

                <Input label="Name" name="name" type="text" register={register} defaultValue={employee.name}/>
                {errors.name && <p className="text-red-500 dark:text-red-400">{errors.name.message}</p>}

                <Input label="Email" name="email" type="email" register={register} defaultValue={employee.email}/>
                {errors.email && <p className="text-red-500 dark:text-red-400">{errors.email.message}</p>}

                <SelectContainer name="role" options={EMPLOYEE_ROLES} placeholder="Role" control={control}/>
                {errors.role && <p className="text-red-500 dark:text-red-400">{errors.role.message}</p>}

                {isProcessing ? 
                    <OrangeButton>Processing...</OrangeButton>
                : 
                    <Submit label={method === "POST" ? "Create Employee" : "Update Employee"} isSubmitting={isProcessing}/>
                }
            </GenericFormBGContainer>
        </GenericForm>
    )
}
